// extracted by mini-css-extract-plugin
export default {"box":"messenger_box__czhGH","toggle":"messenger_toggle__hDSyu"};